import React from 'react';

interface DropdownArrowIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const DropdownArrowIcon: React.FC<DropdownArrowIconProps> = ({ 
  size = 18, 
  color = '#6e6e6e' ,
  className
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 18 18"
      className={className}
    >
      <path 
        fill={color} 
        d="M5.25 7.5 9 11.25l3.75-3.75z"
      />
    </svg>
  );
};

